<template>
  <div class="announcement" v-if="announcement.message">
    <div v-if="announcement.link">
      <router-link :to="announcement.link" class="bar position-relative sd-notif warning">
        <svg-icon icon="information" class="warning-icon" />
        <span class="announcement-message">{{ announcement.message }}</span>
        <svg-icon icon="chevron_e" />
      </router-link>
    </div>
    <div v-else class="bar position-relative sd-notif warning">
        <svg-icon icon="information" class="warning-icon" />
        <span class="announcement-message">{{ announcement.message }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    announcement: {
      type: Object,
      required: true
    }
  },
  methods: mapActions("announcement", ["add"])
};
</script>

<style scoped>
.announcement .announcement-message {
  width: 100%;
}

.announcement .sd-notif {
  padding: 15px 15px;
  align-items: center;
  font-size: 14px;
  border-radius: 10px;
  color: #64513D;
}

.announcement svg {
  display: flex;
}

.announcement a .svg-container:first-child {
  margin-right: 15px;
}

.announcement a .svg-container:last-child {
  margin-left: 15px;
}

.announcement a /deep/.svg-container:first-child svg {
  margin-right: 0;
}

.announcement a /deep/.svg-container:last-child svg {
  height: 12px;
  margin-right: 0;
}
</style>
